module.exports = __webpack_public_path__ + "static/media/eng_d_2467.d9426291.mp4";